import type { HTTPClient } from './client';
import type { Subscription } from './types';

export const initSubscriptions = (client: HTTPClient) => ({
  list: () => {
    return client.get<Subscription[]>(`v1/subscriptions`);
  },
});
